class FetchStaffMembers {
	constructor(public readonly organizationId: number) {
		Object.freeze(this);
	}
}

export default FetchStaffMembers;
